import React from "react";
import {
  SearchInputComponent,
  SelectInputComponent,
} from "../../../../common/components";
import { ORCodeFilterProps } from "./qr-code-filter.props";
import "./qr-code-filter.scss";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import MODULES from "../../../../constants/modules";

const ORCodeFilter: React.FC<ORCodeFilterProps> = (props: any) => {
  const {
    onSearch,
    searchRef,
    isResetSearch,
    handleClickCreateNewForm,
    onTypeChange,
    selectedType,
  } = props;
  
  const { canWrite} = useResourcePermissions(
    MODULES.LEAD_CAPTURE
  );

  const typeOptions = [
    { value: "", label: "All" },
    { value: "LeadCaptureForm", label: "Lead Capture Form" },
    { value: "SurveyForm", label: "Survey Form" },
    { value: "LandingPage", label: "Landing Page" }
  ];

  return (
    <div className="lead-capture-lead-list-search-filter-wrapper">
      <div className="lead-capture-lead-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Name,Type"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div>
        <SelectInputComponent
          fieldName="leadSource"
          placeholder="Select Type"
          options={typeOptions}
          onChange={onTypeChange}
          value={selectedType ? typeOptions.find(option => option.value === selectedType)?.label : "All"}
        />
      </div>
    </div>
  );
};

export default ORCodeFilter;